import React from "react";
import { DesktopIcon } from "../../../../assets/DesktopIcon";
import { MobileIcon } from "../../../../assets/MobileIcon";
import { SlideCardImage } from "./CarouselSlideCardImage";
import { CarouselSlideTypeBadge } from "./CarouselSlideTypeBadge";

interface CarouselSlideImageCardProps {
    index: number;
    title: string;
    desktopSrc: string;
    mobileSrc: string;
    isDragging: boolean;
    onEdit: () => void;
    onRemove: (i: number) => void;
    onDragStart: (idx: number, e: React.DragEvent) => void;
    onDragOver: (e: React.DragEvent) => void;
    onDrop: (idx: number, e: React.DragEvent) => void;
    onDragEnd: () => void;
    onTouchStart: (idx: number) => void;
    onTouchMove: (e: React.TouchEvent) => void;
    onTouchEnd: () => void;
}

export function CarouselImageSlideCard({
    index,
    title,
    desktopSrc,
    mobileSrc,
    onEdit,
    onRemove,
    isDragging,
    onDragStart,
    onDragOver,
    onDrop,
    onDragEnd,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
}: CarouselSlideImageCardProps) {
    return (
        <div
            className={`slideCard expanded ${isDragging ? "is-dragging" : ""}`}
            onDragOver={onDragOver}
            onDrop={(e) => onDrop(index, e)}
            onTouchStart={() => onTouchStart(index)}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            data-index={index}
        >
            <div className="slideCard__number">{index + 1}</div>
            <div className="slideCard__panel">
                <CarouselSlideTypeBadge type="image" />
                <button
                    className="slideCard__drag"
                    aria-label="reorder"
                    draggable
                    onDragStart={(e) => onDragStart(index, e)}
                    onDragEnd={onDragEnd}
                >
                    <span className="slideCard__dragIcon" />
                </button>
                <div className="slideCard__content">
                    <div className="slideCard__header">
                        <h4 className="slideCard__title">{title}</h4>
                    </div>
                    <div className="slideCard__media">
                        <div className="slideCard__desktop">
                            <SlideCardImage src={desktopSrc} alt="Desktop view" />
                            <div className="slideCard__caption">
                                <DesktopIcon />
                                <span>Desktop view</span>
                            </div>
                        </div>
                        <div className="slideCard__mobile">
                            <SlideCardImage src={mobileSrc} alt="Mobile view" />
                            <div className="slideCard__caption">
                                <MobileIcon />
                                <span>Mobile View</span>
                            </div>
                        </div>
                    </div>
                    <div className="slideCard__actions">
                        <button className="slideCard__btn--edit" onClick={onEdit}>
                            <span className="slideCard__btnIcon slideCard__btnIcon--edit" />
                            <span className="slideCard__btnText">Edit</span>
                        </button>
                        <button className="slideCard__btn--delete" onClick={() => onRemove(index)}>
                            <span className="slideCard__btnIcon slideCard__btnIcon--delete" />
                            <span className="slideCard__btnText">Delete</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}